export const FEATURE_KEYS = {
  operatorBookingManagement: 'operator-booking-management',
  passengerBooking: 'passenger-booking',
  passengerProfiles: 'passenger-profiles'
} as const;

export type FeatureKey = typeof FEATURE_KEYS[keyof typeof FEATURE_KEYS] | string;

export interface FeatureFlag {
  featureFlagID: number;
  key: string;
  displayName: string;
  description: string;
  isEnabled: boolean;
  modifiedDate: string | null;
  modifiedByUserID: number | null;
  audienceOverrides: FeatureFlagAudienceOverride[];
}

export type FeatureStates = Record<string, boolean>;

export type FeatureAudienceRole = 'admin' | 'platform_employee' | 'operator' | 'passenger' | 'driver' | string;

export interface FeatureFlagAudienceOverride {
  featureFlagAudienceOverrideID?: number;
  role: FeatureAudienceRole;
  operatorType: string | null;
  isEnabled: boolean;
  modifiedDate?: string | null;
  modifiedByUserID?: number | null;
}

export interface FeatureFlagAudienceUpdate {
  role: FeatureAudienceRole;
  operatorType: string | null;
  isEnabled: boolean | null;
}

export interface FeatureFlagUpdate {
  isEnabled?: boolean;
  audienceOverrides?: FeatureFlagAudienceUpdate[];
}

export interface FeatureDisabledProblem {
  title: string;
  status: number;
  detail: string;
  featureKey: string;
}
